import * as Yup from 'yup';

const resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .trim()
        .min(8, 'Password must be at least 8 characters.')
        .required('Password is required.'),
    repeatPassword: Yup.string()
        .trim()
        .oneOf([Yup.ref('password'), null], 'Passwords do not match.')
        .required('Repeat password is required.'),
});

export default resetPasswordSchema;
